import { Employer } from 'services/requests';
import { useModalState } from 'hooks/modals';
import { EditIcon_16 } from 'assets/icons';
import styles from './EmployersEditButton.module.css';
import EmployersModal from '../EmployersModal';

type Props = {
  employer: Employer;
  onEdit?: (employer: Employer) => void;
};

const EmployersEditButton = ({ employer, onEdit }: Props): JSX.Element | null => {
  const { isModalVisible, openModal, closeModal } = useModalState();

  const onClick = () => {
    !!onEdit && onEdit(employer);
    openModal();
  };

  return (
    <div
      className={styles.employersEditButton}
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      title={'edit employer'}
    >
      <EditIcon_16 onClick={onClick} className={styles.employersEditButton__icon} />
      {isModalVisible && (
        <EmployersModal
          employer={employer}
          onRequestClose={closeModal}
          isOpen={isModalVisible}
        />
      )}
    </div>
  );
};

export default EmployersEditButton;
